export default {
  Group1: {
    TextualSearchs: [
      { Text: "Man-made Features", Value: "ManMadeFeatureSearchBox" },
      { Text: "Road / Building / Place", Value: "StreetNameSearchBox" },
      { Text: "Lot Number", Value: "LotNumberSearchBox" },
      { Text: "Lamp Post", Value: "LampPostSearchBox" },
      { Text: "Coordinates", Value: "CoordinatesSearchBox" },
      { Text: "GIU Report", Value: "GIReportSearchBox" },
      {
        Text: "Active Sites - Districts",
        Value: "ActiveSitesDistrictsSearchBox",
      },
      {
        Text: "Active Sites - Civil Engineering Projects",
        Value: "ActiveSitesCEProjectSearchBox",
      },
      { Text: "Active Sites - LPM", Value: "ActiveSitesLPMSearchBox" },
      { Text: "Blasting Sites", Value: "BlastingSitesSearchBox" },
      { Text: "Boulder", Value: "BoulderSearchBox" },
      { Text: "CEDD - TGLA", Value: "CEDDTGLASearchBox" },
      { Text: "DADS", Value: "DADSSearchBox" },
      { Text: "Development Projects", Value: "DevelopmentProjectsSearchBox" },
      { Text: "ENTLI", Value: "ENTLISearchBox" },
      {
        Text: "Feature Status Review / Slope Checking Status",
        Value: "FSRSCSSearchBox",
      },
      { Text: "GCC Cases", Value: "GCCSearchBox" },
      { Text: "Hillside Pocket", Value: "HillsidePocketSearchBox" },
      { Text: "Historical Landslide Catchment (2016)", Value: "HLCSearchBox" },
      {
        Text: "Incidents (Confirmed / To be confirmed)",
        Value: "IncidentSearchBox",
      },
      { Text: "Issued DBEL", Value: "BulkExcavationSearchBox" },
      { Text: "LPM Stage 2(H) Study", Value: "LPMS2HSearchBox" },
      { Text: "LPM Stage 3(H) Study", Value: "LPMS3HSearchBox" },
      { Text: "Land Matter", Value: "LandMatterSearchBox" },
      { Text: "Landslide Studies Report Areas", Value: "LSRSearchBox" },
      { Text: "Map Sheet", Value: "MapSheetSearchBox" },
      { Text: "Mitigated Hillside (MH) Features", Value: "MHSearchBox" },
      { Text: "NT Exempted House", Value: "NTEHSearchBox" },
      { Text: "NTHS (District)", Value: "NTHSSearchBox" },
      {
        Text: "Registered Squatter Dwelling - with CAF in force",
        Value: "KSSWithNDCSearchBox",
      },
      { Text: "Tension Crack (Known)", Value: "TensionCrackSearchBox" },
      { Text: "Tunnel Submission Records", Value: "TunnelSearchBox" },
      { Text: "Unauthorized Slope Works", Value: "USWSearchBox" },
    ],
    Schemas: [
      {
        Text: "SlopeInfo",
        Value: "SlopeInfo",
        GraphicalSearchs: [
          { Text: "Active Sites - Civil Engg. Projects" },
          { Text: "Active Sites - LPM" },
          { Text: "Advisory Letter Cases" },
          { Text: "Advisory Letters" },
          { Text: "Advisory Projects" },
          { Text: "CEDD - TGLA" },
          { Text: "DH Cases" },
          { Text: "DH Files" },
          { Text: "DH Orders" },
          { Text: "District Engineer Area" },
          { Text: "Emergency Works Services" },
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Feature Status Review (FSR)" },
          { Text: "GCC Cases" },
          { Text: "Ground Anchor" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Horizontal Drain" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Issued DBEL" },
          { Text: "Landslide Studies Report Areas" },
          { Text: "Land Matter" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "NT Exempted House" },
          { Text: "Private Projects" },
          { Text: "Public Projects" },
          { Text: "Registered Squatter Dwelling - with CAF in force" },
          { Text: "Slope Checking Status (SCS)" },
          { Text: "Squatter Structure - close to slope" },
          { Text: "Stage 2 Study" },
          { Text: "Stage 3 Study" },
          { Text: "Stage 2(H) Study" },
          { Text: "Stage 3(H) Study" },
          { Text: "Unauthorized Slope Works" },
          { Text: "Works Upgrading Boundary" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "NTInformSys",
        Value: "NTInformSys",
        GraphicalSearchs: [
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Landslide Studies Report Areas" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "LPMIS",
        Value: "LPMIS",
        GraphicalSearchs: [
          { Text: "Active Sites - Polygon" },
          { Text: "Emergency Works Services" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "Stage 2 Study" },
          { Text: "Stage 3 Study" },
          { Text: "Stage 2(H) Study" },
          { Text: "Stage 3(H) Study" },
          { Text: "Works Upgrading Boundary" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "District",
        Value: "District",
        GraphicalSearchs: [
          { Text: "Active Sites - Polygon" },
          { Text: "Advisory Letter Cases" },
          { Text: "Advisory Letters" },
          { Text: "Advisory Projects" },
          { Text: "Antiquities and Monuments" },
          { Text: "Borehole Location" },
          { Text: "Boulder" },
          { Text: "DH Cases" },
          { Text: "DH Files" },
          { Text: "DH Orders" },
          { Text: "District Engineer Area" },
          { Text: "Disused Tunnel" },
          { Text: "Drainage and Sewage Tunnel Protection Zone" },
          { Text: "Emergency Works Services" },
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Feature Status Review (FSR)" },
          { Text: "GCC Cases" },
          { Text: "Ground Anchor" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Horizontal Drain" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Issued DBEL" },
          { Text: "Land Matter" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "NT Exempted House" },
          { Text: "NTHS (District)" },
          { Text: "Private Projects" },
          { Text: "Public Projects" },
          { Text: "Registered Squatter Dwelling - with CAF in force" },
          { Text: "Slope Checking Status (SCS)" },
          { Text: "Squatter Structure - close to slope" },
          { Text: "Stage 2 Study" },
          { Text: "Stage 3 Study" },
          { Text: "Stage 2(H) Study" },
          { Text: "Stage 3(H) Study" },
          { Text: "Strategic Cavern Areas" },
          { Text: "Tunnel Submission Records" },
          { Text: "Unauthorized Slope Works" },
          { Text: "Works Upgrading Boundary" },
          { Text: "Dangerous Road Sign" },
          { Text: "Squatter Warning Sign" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "GIRecord",
        Value: "GIRecord",
        GraphicalSearchs: [
          { Text: "GIU Report" },
          { Text: "GI Location", Default: true },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "Man-made Features" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "Planning",
        Value: "Planning",
        GraphicalSearchs: [
          { Text: "Boulder" },
          { Text: "Disused Tunnel" },
          { Text: "Drainage and Sewage Tunnel Protection Zone" },
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Landslide Studies Report Areas" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "Planning Comment (Area > 1 km2)" },
          { Text: "Planning Comment (Area < 1 km2)" },
          { Text: "Strategic Cavern Areas" },
          { Text: "Tension Crack (known)" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "Emergency",
        Value: "Emergency",
        GraphicalSearchs: [
          { Text: "Active Sites - Polygon" },
          { Text: "Advisory Letter Cases" },
          { Text: "Advisory Letters" },
          { Text: "Advisory Projects" },
          { Text: "Antiquities and Monuments" },
          { Text: "DH Cases" },
          { Text: "DH Files" },
          { Text: "DH Orders" },
          { Text: "Emergency Works Services" },
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Feature Status Review (FSR)" },
          { Text: "Ground Anchor" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Horizontal Drain" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Landslide Studies Report Areas" },
          { Text: "Land Matter" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "NT Exempted House" },
          { Text: "NTHS (District)" },
          { Text: "Private Projects" },
          { Text: "Public Projects" },
          { Text: "Registered Squatter Dwelling - with CAF in force" },
          { Text: "Slope Checking Status (SCS)" },
          { Text: "Squatter Structure - close to slope" },
          { Text: "Stage 2 Study" },
          { Text: "Stage 3 Study" },
          { Text: "Stage 2(H) Study" },
          { Text: "Stage 3(H) Study" },
          { Text: "Unauthorized Slope Works" },
          { Text: "Works Upgrading Boundary" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "LandLot",
        Value: "iC1000_ginfo",
        GraphicalSearchs: [{ Text: "CUSTOM" }],
      },
      {
        Text: "DistrictArea",
        Value: "DistrictArea",
        GraphicalSearchs: [{ Text: "CUSTOM" }],
      },
    ],
  },

  Group2: {
    TextualSearchs: [
      { Text: "Man-made Features", Value: "ManMadeFeatureSearchBox" },
      { Text: "Road / Building / Place", Value: "StreetNameSearchBox" },
      { Text: "Lot Number", Value: "LotNumberSearchBox" },
      { Text: "Lamp Post", Value: "LampPostSearchBox" },
      { Text: "Coordinates", Value: "CoordinatesSearchBox" },
      { Text: "GIU Report", Value: "GIReportSearchBox" },
      {
        Text: "Active Sites - Districts",
        Value: "ActiveSitesDistrictsSearchBox",
      },
      {
        Text: "Active Sites - Civil Engineering Projects",
        Value: "ActiveSitesCEProjectSearchBox",
      },
      { Text: "Active Sites - LPM", Value: "ActiveSitesLPMSearchBox" },
      { Text: "Blasting Sites", Value: "BlastingSitesSearchBox" },
      { Text: "Boulder", Value: "BoulderSearchBox" },
      { Text: "CEDD - TGLA", Value: "CEDDTGLASearchBox" },
      { Text: "DADS", Value: "DADSSearchBox" },
      { Text: "Development Projects", Value: "DevelopmentProjectsSearchBox" },
      { Text: "ENTLI", Value: "ENTLISearchBox" },
      {
        Text: "Feature Status Review / Slope Checking Status",
        Value: "FSRSCSSearchBox",
      },
      { Text: "GCC Cases", Value: "GCCSearchBox" },
      { Text: "Hillside Pocket", Value: "HillsidePocketSearchBox" },
      { Text: "Historical Landslide Catchment (2016)", Value: "HLCSearchBox" },
      {
        Text: "Incidents (Confirmed / To be confirmed)",
        Value: "IncidentSearchBox",
      },
      { Text: "Issued DBEL", Value: "BulkExcavationSearchBox" },
      { Text: "LPM Stage 2(H) Study", Value: "LPMS2HSearchBox" },
      { Text: "LPM Stage 3(H) Study", Value: "LPMS3HSearchBox" },
      { Text: "Land Matter", Value: "LandMatterSearchBox" },
      { Text: "Landslide Studies Report Areas", Value: "LSRSearchBox" },
      { Text: "Map Sheet", Value: "MapSheetSearchBox" },
      { Text: "Mitigated Hillside (MH) Features", Value: "MHSearchBox" },
      { Text: "NT Exempted House", Value: "NTEHSearchBox" },
      { Text: "NTHS (District)", Value: "NTHSSearchBox" },
      {
        Text: "Registered Squatter Dwelling - with CAF in force",
        Value: "KSSWithNDCSearchBox",
      },
      { Text: "Tension Crack (Known)", Value: "TensionCrackSearchBox" },
      { Text: "Tunnel Submission Records", Value: "TunnelSearchBox" },
      { Text: "Unauthorized Slope Works", Value: "USWSearchBox" },
    ],
    Schemas: [
      {
        Text: "SlopeInfo",
        Value: "SlopeInfo",
        GraphicalSearchs: [
          { Text: "Active Sites - Civil Engg. Projects" },
          { Text: "Active Sites - LPM" },
          { Text: "Advisory Letter Cases" },
          { Text: "Advisory Letters" },
          { Text: "Advisory Projects" },
          { Text: "CEDD - TGLA" },
          { Text: "DH Cases" },
          { Text: "DH Files" },
          { Text: "DH Orders" },
          { Text: "District Engineer Area" },
          { Text: "Emergency Works Services" },
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Feature Status Review (FSR)" },
          { Text: "GCC Cases" },
          { Text: "Ground Anchor" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Horizontal Drain" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Issued DBEL" },
          { Text: "Landslide Studies Report Areas" },
          { Text: "Land Matter" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "NT Exempted House" },
          { Text: "Private Projects" },
          { Text: "Public Projects" },
          { Text: "Registered Squatter Dwelling - with CAF in force" },
          { Text: "Slope Checking Status (SCS)" },
          { Text: "Squatter Structure - close to slope" },
          { Text: "Stage 2 Study" },
          { Text: "Stage 3 Study" },
          { Text: "Stage 2(H) Study" },
          { Text: "Stage 3(H) Study" },
          { Text: "Unauthorized Slope Works" },
          { Text: "Works Upgrading Boundary" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "NTInformSys",
        Value: "NTInformSys",
        GraphicalSearchs: [
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Landslide Studies Report Areas" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "LPMIS",
        Value: "LPMIS",
        GraphicalSearchs: [
          { Text: "Active Sites - Polygon" },
          { Text: "Emergency Works Services" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "Stage 2 Study" },
          { Text: "Stage 3 Study" },
          { Text: "Stage 2(H) Study" },
          { Text: "Stage 3(H) Study" },
          { Text: "Works Upgrading Boundary" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "District",
        Value: "District",
        GraphicalSearchs: [
          { Text: "Active Sites - Polygon" },
          { Text: "Advisory Letter Cases" },
          { Text: "Advisory Letters" },
          { Text: "Advisory Projects" },
          { Text: "Antiquities and Monuments" },
          { Text: "Borehole Location" },
          { Text: "Boulder" },
          { Text: "DH Cases" },
          { Text: "DH Files" },
          { Text: "DH Orders" },
          { Text: "Disused Tunnel" },
          { Text: "Drainage and Sewage Tunnel Protection Zone" },
          { Text: "Emergency Works Services" },
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Feature Status Review (FSR)" },
          { Text: "GCC Cases" },
          { Text: "District Engineer Area" },
          { Text: "Ground Anchor" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Horizontal Drain" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Issued DBEL" },
          { Text: "Land Matter" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "NT Exempted House" },
          { Text: "NTHS (District)" },
          { Text: "Private Projects" },
          { Text: "Public Projects" },
          { Text: "Registered Squatter Dwelling - with CAF in force" },
          { Text: "Slope Checking Status (SCS)" },
          { Text: "Squatter Structure - close to slope" },
          { Text: "Stage 2 Study" },
          { Text: "Stage 3 Study" },
          { Text: "Stage 2(H) Study" },
          { Text: "Stage 3(H) Study" },
          { Text: "Strategic Cavern Areas" },
          { Text: "Tunnel Submission Records" },
          { Text: "Unauthorized Slope Works" },
          { Text: "Works Upgrading Boundary" },
          { Text: "Dangerous Road Sign" },
          { Text: "Squatter Warning Sign" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "GIRecord",
        Value: "GIRecord",
        GraphicalSearchs: [
          { Text: "GIU Report" },
          { Text: "GI Location", Default: true },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "Man-made Features" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "Planning",
        Value: "Planning",
        GraphicalSearchs: [
          { Text: "Boulder" },
          { Text: "Disused Tunnel" },
          { Text: "Drainage and Sewage Tunnel Protection Zone" },
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Landslide Studies Report Areas" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "Planning Comment (Area > 1 km2)" },
          { Text: "Planning Comment (Area < 1 km2)" },
          { Text: "Strategic Cavern Areas" },
          { Text: "Tension Crack (known)" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "Emergency",
        Value: "Emergency",
        GraphicalSearchs: [
          { Text: "Active Sites - Polygon" },
          { Text: "Advisory Letter Cases" },
          { Text: "Advisory Letters" },
          { Text: "Advisory Projects" },
          { Text: "Antiquities and Monuments" },
          { Text: "DH Cases" },
          { Text: "DH Files" },
          { Text: "DH Orders" },
          { Text: "Emergency Works Services" },
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Feature Status Review (FSR)" },
          { Text: "Ground Anchor" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Horizontal Drain" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Landslide Studies Report Areas" },
          { Text: "Land Matter" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "NT Exempted House" },
          { Text: "NTHS (District)" },
          { Text: "Private Projects" },
          { Text: "Public Projects" },
          { Text: "Registered Squatter Dwelling - with CAF in force" },
          { Text: "Slope Checking Status (SCS)" },
          { Text: "Squatter Structure - close to slope" },
          { Text: "Stage 2 Study" },
          { Text: "Stage 3 Study" },
          { Text: "Stage 2(H) Study" },
          { Text: "Stage 3(H) Study" },
          { Text: "Unauthorized Slope Works" },
          { Text: "Works Upgrading Boundary" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "LandLot",
        Value: "iC1000_ginfo",
        GraphicalSearchs: [{ Text: "CUSTOM" }],
      },
      {
        Text: "DistrictArea",
        Value: "DistrictArea",
        GraphicalSearchs: [{ Text: "CUSTOM" }],
      },
    ],
  },

  Group3: {
    TextualSearchs: [
      { Text: "Man-made Features", Value: "ManMadeFeatureSearchBox" },
      { Text: "Road / Building / Place", Value: "StreetNameSearchBox" },
      { Text: "Lot Number", Value: "LotNumberSearchBox" },
      { Text: "Lamp Post", Value: "LampPostSearchBox" },
      { Text: "Coordinates", Value: "CoordinatesSearchBox" },
      { Text: "GIU Report", Value: "GIReportSearchBox" },
      {
        Text: "Active Sites - Districts",
        Value: "ActiveSitesDistrictsSearchBox",
      },
      {
        Text: "Active Sites - Civil Engineering Projects",
        Value: "ActiveSitesCEProjectSearchBox",
      },
      { Text: "Active Sites - LPM", Value: "ActiveSitesLPMSearchBox" },
      { Text: "Blasting Sites", Value: "BlastingSitesSearchBox" },
      { Text: "Boulder", Value: "BoulderSearchBox" },
      { Text: "CEDD - TGLA", Value: "CEDDTGLASearchBox" },
      { Text: "DADS", Value: "DADSSearchBox" },
      { Text: "Development Projects", Value: "DevelopmentProjectsSearchBox" },
      { Text: "ENTLI", Value: "ENTLISearchBox" },
      {
        Text: "Feature Status Review / Slope Checking Status",
        Value: "FSRSCSSearchBox",
      },
      { Text: "GCC Cases", Value: "GCCSearchBox" },
      { Text: "Hillside Pocket", Value: "HillsidePocketSearchBox" },
      { Text: "Historical Landslide Catchment (2016)", Value: "HLCSearchBox" },
      {
        Text: "Incidents (Confirmed / To be confirmed)",
        Value: "IncidentSearchBox",
      },
      { Text: "Issued DBEL", Value: "BulkExcavationSearchBox" },
      { Text: "LPM Stage 2(H) Study", Value: "LPMS2HSearchBox" },
      { Text: "LPM Stage 3(H) Study", Value: "LPMS3HSearchBox" },
      { Text: "Land Matter", Value: "LandMatterSearchBox" },
      { Text: "Landslide Studies Report Areas", Value: "LSRSearchBox" },
      { Text: "Map Sheet", Value: "MapSheetSearchBox" },
      { Text: "Mitigated Hillside (MH) Features", Value: "MHSearchBox" },
      { Text: "NT Exempted House", Value: "NTEHSearchBox" },
      { Text: "NTHS (District)", Value: "NTHSSearchBox" },
      {
        Text: "Registered Squatter Dwelling - with CAF in force",
        Value: "KSSWithNDCSearchBox",
      },
      { Text: "Tension Crack (Known)", Value: "TensionCrackSearchBox" },
      { Text: "Tunnel Submission Records", Value: "TunnelSearchBox" },
      { Text: "Unauthorized Slope Works", Value: "USWSearchBox" },
    ],
    Schemas: [
      {
        Text: "SlopeInfo",
        Value: "SlopeInfo",
        GraphicalSearchs: [
          { Text: "Active Sites - Civil Engg. Projects" },
          { Text: "Active Sites - LPM" },
          { Text: "Advisory Letter Cases" },
          { Text: "Advisory Letters" },
          { Text: "Advisory Projects" },
          { Text: "CEDD - TGLA" },
          { Text: "DH Cases" },
          { Text: "DH Files" },
          { Text: "DH Orders" },
          { Text: "District Engineer Area" },
          { Text: "Emergency Works Services" },
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Feature Status Review (FSR)" },
          { Text: "GCC Cases" },
          { Text: "Ground Anchor" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Horizontal Drain" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Issued DBEL" },
          { Text: "Landslide Studies Report Areas" },
          { Text: "Land Matter" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "NT Exempted House" },
          { Text: "Private Projects" },
          { Text: "Public Projects" },
          { Text: "Registered Squatter Dwelling - with CAF in force" },
          { Text: "Slope Checking Status (SCS)" },
          { Text: "Squatter Structure - close to slope" },
          { Text: "Stage 2 Study" },
          { Text: "Stage 3 Study" },
          { Text: "Stage 2(H) Study" },
          { Text: "Stage 3(H) Study" },
          { Text: "Unauthorized Slope Works" },
          { Text: "Works Upgrading Boundary" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "NTInformSys",
        Value: "NTInformSys",
        GraphicalSearchs: [
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Landslide Studies Report Areas" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "LPMIS",
        Value: "LPMIS",
        GraphicalSearchs: [
          { Text: "Active Sites - Polygon" },
          { Text: "Emergency Works Services" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "Stage 2 Study" },
          { Text: "Stage 3 Study" },
          { Text: "Stage 2(H) Study" },
          { Text: "Stage 3(H) Study" },
          { Text: "Works Upgrading Boundary" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "District",
        Value: "District",
        GraphicalSearchs: [
          { Text: "Active Sites - Polygon" },
          { Text: "Advisory Letter Cases" },
          { Text: "Advisory Letters" },
          { Text: "Advisory Projects" },
          { Text: "Antiquities and Monuments" },
          { Text: "Borehole Location" },
          { Text: "Boulder" },
          { Text: "DH Cases" },
          { Text: "DH Files" },
          { Text: "DH Orders" },
          { Text: "Disused Tunnel" },
          { Text: "Drainage and Sewage Tunnel Protection Zone" },
          { Text: "Emergency Works Services" },
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Feature Status Review (FSR)" },
          { Text: "GCC Cases" },
          { Text: "District Engineer Area" },
          { Text: "Ground Anchor" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Horizontal Drain" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Issued DBEL" },
          { Text: "Land Matter" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "NT Exempted House" },
          { Text: "NTHS (District)" },
          { Text: "Private Projects" },
          { Text: "Public Projects" },
          { Text: "Registered Squatter Dwelling - with CAF in force" },
          { Text: "Slope Checking Status (SCS)" },
          { Text: "Squatter Structure - close to slope" },
          { Text: "Stage 2 Study" },
          { Text: "Stage 3 Study" },
          { Text: "Stage 2(H) Study" },
          { Text: "Stage 3(H) Study" },
          { Text: "Strategic Cavern Areas" },
          { Text: "Tunnel Submission Records" },
          { Text: "Unauthorized Slope Works" },
          { Text: "Works Upgrading Boundary" },
          { Text: "Dangerous Road Sign" },
          { Text: "Squatter Warning Sign" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "GIRecord",
        Value: "GIRecord",
        GraphicalSearchs: [
          { Text: "GIU Report" },
          { Text: "GI Location", Default: true },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "Man-made Features" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "Planning",
        Value: "Planning",
        GraphicalSearchs: [
          { Text: "Boulder" },
          { Text: "Disused Tunnel" },
          { Text: "Drainage and Sewage Tunnel Protection Zone" },
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Landslide Studies Report Areas" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "Planning Comment (Area > 1 km2)" },
          { Text: "Planning Comment (Area < 1 km2)" },
          { Text: "Strategic Cavern Areas" },
          { Text: "Tension Crack (known)" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "Emergency",
        Value: "Emergency",
        GraphicalSearchs: [
          { Text: "Active Sites - Polygon" },
          { Text: "Advisory Letter Cases" },
          { Text: "Advisory Letters" },
          { Text: "Advisory Projects" },
          { Text: "Antiquities and Monuments" },
          { Text: "DH Cases" },
          { Text: "DH Files" },
          { Text: "DH Orders" },
          { Text: "Emergency Works Services" },
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Feature Status Review (FSR)" },
          { Text: "Ground Anchor" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Horizontal Drain" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Landslide Studies Report Areas" },
          { Text: "Land Matter" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "NT Exempted House" },
          { Text: "NTHS (District)" },
          { Text: "Private Projects" },
          { Text: "Public Projects" },
          { Text: "Registered Squatter Dwelling - with CAF in force" },
          { Text: "Slope Checking Status (SCS)" },
          { Text: "Squatter Structure - close to slope" },
          { Text: "Stage 2 Study" },
          { Text: "Stage 3 Study" },
          { Text: "Stage 2(H) Study" },
          { Text: "Stage 3(H) Study" },
          { Text: "Unauthorized Slope Works" },
          { Text: "Works Upgrading Boundary" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "LandLot",
        Value: "iC1000_ginfo",
        GraphicalSearchs: [{ Text: "CUSTOM" }],
      },
      {
        Text: "DistrictArea",
        Value: "DistrictArea",
        GraphicalSearchs: [{ Text: "CUSTOM" }],
      },
    ],
  },

  Group4: {
    TextualSearchs: [
      { Text: "Man-made Features", Value: "ManMadeFeatureSearchBox" },
      { Text: "Road / Building / Place", Value: "StreetNameSearchBox" },
      { Text: "Lot Number", Value: "LotNumberSearchBox" },
      { Text: "Lamp Post", Value: "LampPostSearchBox" },
      { Text: "Coordinates", Value: "CoordinatesSearchBox" },
      { Text: "GIU Report", Value: "GIReportSearchBox" },
      { Text: "Issued DBEL", Value: "BulkExcavationSearchBox" },
    ],
    Schemas: [
      {
        Text: "SlopeInfo",
        Value: "SlopeInfo",
        GraphicalSearchs: [
          { Text: "Advisory Projects" },
          { Text: "GHB & Soil Nails Clauses" },
          { Text: "Issued DBEL" },
          { Text: "Man-made Features", Default: true },
          { Text: "Private Projects" },
          { Text: "Public Projects" },
          { Text: "Stage 2 Study" },
          { Text: "Stage 3 Study" },
        ],
      },
      {
        Text: "GIRecord",
        Value: "GIRecord",
        GraphicalSearchs: [
          { Text: "GIU Report" },
          { Text: "GI Location", Default: true },
          { Text: "Man-made Features" },
        ],
      },
      {
        Text: "LandLot",
        Value: "iC1000_ginfo",
        GraphicalSearchs: [],
      },
      {
        Text: "DistrictArea",
        Value: "DistrictArea",
        GraphicalSearchs: [],
      },
    ],
  },

  Group5: {
    TextualSearchs: [
      { Text: "Man-made Features", Value: "ManMadeFeatureSearchBox" },
      { Text: "Road / Building / Place", Value: "StreetNameSearchBox" },
      { Text: "Lot Number", Value: "LotNumberSearchBox" },
      { Text: "Lamp Post", Value: "LampPostSearchBox" },
      { Text: "Coordinates", Value: "CoordinatesSearchBox" },
      { Text: "GIU Report", Value: "GIReportSearchBox" },
      { Text: "Issued DBEL", Value: "BulkExcavationSearchBox" },
    ],
    Schemas: [
      {
        Text: "GIRecord",
        Value: "GIRecord",
        GraphicalSearchs: [
          { Text: "GIU Report" },
          { Text: "GI Location", Default: true },
          { Text: "Man-made Features" },
        ],
      },
      {
        Text: "DistrictArea",
        Value: "DistrictArea",
        GraphicalSearchs: [],
      },
      {
        Text: "BulkExcLimit",
        Value: "BulkExcLimit",
        GraphicalSearchs: [{ Text: "Issued DBEL" }],
      },
    ],
  },

  Group6: {
    TextualSearchs: [
      { Text: "Man-made Features", Value: "ManMadeFeatureSearchBox" },
      { Text: "Road / Building / Place", Value: "StreetNameSearchBox" },
      { Text: "Lot Number", Value: "LotNumberSearchBox" },
      { Text: "Lamp Post", Value: "LampPostSearchBox" },
      { Text: "Coordinates", Value: "CoordinatesSearchBox" },
      { Text: "Issued DBEL", Value: "BulkExcavationSearchBox" },
    ],
    Schemas: [
      {
        Text: "GIRecord",
        Value: "GIRecord",
        GraphicalSearchs: [{ Text: "Man-made Features", Default: true }],
      },
      {
        Text: "DistrictArea",
        Value: "DistrictArea",
        GraphicalSearchs: [],
      },
      {
        Text: "BulkExcLimit",
        Value: "BulkExcLimit",
        GraphicalSearchs: [{ Text: "Issued DBEL" }],
      },
    ],
  },

  Group7: {
    TextualSearchs: [
      { Text: "Man-made Features", Value: "ManMadeFeatureSearchBox" },
      { Text: "Road / Building / Place", Value: "StreetNameSearchBox" },
      { Text: "Lot Number", Value: "LotNumberSearchBox" },
      { Text: "Lamp Post", Value: "LampPostSearchBox" },
      { Text: "Coordinates", Value: "CoordinatesSearchBox" },
      {
        Text: "Incidents (Confirmed / To be confirmed)",
        Value: "IncidentSearchBox",
      },
      { Text: "Map Sheet", Value: "MapSheetSearchBox" },
    ],
    Schemas: [
      {
        Text: "ICC",
        Value: "ICC",
        GraphicalSearchs: [
          { Text: "Man-made Features", Default: true },
          { Text: "District Engineer Area" },
        ],
      },
    ],
  },

  Group8: {
    TextualSearchs: [
      { Text: "Man-made Features", Value: "ManMadeFeatureSearchBox" },
      { Text: "Road / Building / Place", Value: "StreetNameSearchBox" },
      { Text: "Lot Number", Value: "LotNumberSearchBox" },
      { Text: "Lamp Post", Value: "LampPostSearchBox" },
      { Text: "Coordinates", Value: "CoordinatesSearchBox" },
      { Text: "GIU Report", Value: "GIReportSearchBox" },
      {
        Text: "Active Sites - Districts",
        Value: "ActiveSitesDistrictsSearchBox",
      },
      {
        Text: "Active Sites - Civil Engineering Projects",
        Value: "ActiveSitesCEProjectSearchBox",
      },
      { Text: "Active Sites - LPM", Value: "ActiveSitesLPMSearchBox" },
      { Text: "Blasting Sites", Value: "BlastingSitesSearchBox" },
      { Text: "Boulder", Value: "BoulderSearchBox" },
      { Text: "CEDD - TGLA", Value: "CEDDTGLASearchBox" },
      { Text: "DADS", Value: "DADSSearchBox" },
      { Text: "Development Projects", Value: "DevelopmentProjectsSearchBox" },
      { Text: "ENTLI", Value: "ENTLISearchBox" },
      {
        Text: "Feature Status Review / Slope Checking Status",
        Value: "FSRSCSSearchBox",
      },
      { Text: "GCC Cases", Value: "GCCSearchBox" },
      { Text: "Hillside Pocket", Value: "HillsidePocketSearchBox" },
      { Text: "Historical Landslide Catchment (2016)", Value: "HLCSearchBox" },
      {
        Text: "Incidents (Confirmed / To be confirmed)",
        Value: "IncidentSearchBox",
      },
      { Text: "Issued DBEL", Value: "BulkExcavationSearchBox" },
      { Text: "LPM Stage 2(H) Study", Value: "LPMS2HSearchBox" },
      { Text: "LPM Stage 3(H) Study", Value: "LPMS3HSearchBox" },
      { Text: "Land Matter", Value: "LandMatterSearchBox" },
      { Text: "Landslide Studies Report Areas", Value: "LSRSearchBox" },
      { Text: "Map Sheet", Value: "MapSheetSearchBox" },
      { Text: "Mitigated Hillside (MH) Features", Value: "MHSearchBox" },
      { Text: "NT Exempted House", Value: "NTEHSearchBox" },
      { Text: "NTHS (District)", Value: "NTHSSearchBox" },
      {
        Text: "Registered Squatter Dwelling - with CAF in force",
        Value: "KSSWithNDCSearchBox",
      },
      { Text: "Tension Crack (Known)", Value: "TensionCrackSearchBox" },
      { Text: "Tunnel Submission Records", Value: "TunnelSearchBox" },
      { Text: "Unauthorized Slope Works", Value: "USWSearchBox" },
    ],
    Schemas: [
      {
        Text: "SlopeInfo",
        Value: "SlopeInfo",
        GraphicalSearchs: [
          { Text: "Active Sites - Civil Engg. Projects" },
          { Text: "Active Sites - LPM" },
          { Text: "Advisory Letter Cases" },
          { Text: "Advisory Letters" },
          { Text: "Advisory Projects" },
          { Text: "CEDD - TGLA" },
          { Text: "DH Cases" },
          { Text: "DH Files" },
          { Text: "DH Orders" },
          { Text: "District Engineer Area" },
          { Text: "Emergency Works Services" },
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Feature Status Review (FSR)" },
          { Text: "GCC Cases" },
          { Text: "Ground Anchor" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Horizontal Drain" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Issued DBEL" },
          { Text: "Landslide Studies Report Areas" },
          { Text: "Land Matter" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "NT Exempted House" },
          { Text: "Private Projects" },
          { Text: "Public Projects" },
          { Text: "Registered Squatter Dwelling - with CAF in force" },
          { Text: "Slope Checking Status (SCS)" },
          { Text: "Squatter Structure - close to slope" },
          { Text: "Stage 2 Study" },
          { Text: "Stage 3 Study" },
          { Text: "Stage 2(H) Study" },
          { Text: "Stage 3(H) Study" },
          { Text: "Unauthorized Slope Works" },
          { Text: "Works Upgrading Boundary" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "NTInformSys",
        Value: "NTInformSys",
        GraphicalSearchs: [
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Landslide Studies Report Areas" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "LPMIS",
        Value: "LPMIS",
        GraphicalSearchs: [
          { Text: "Active Sites - Polygon" },
          { Text: "Emergency Works Services" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "Stage 2 Study" },
          { Text: "Stage 3 Study" },
          { Text: "Stage 2(H) Study" },
          { Text: "Stage 3(H) Study" },
          { Text: "Works Upgrading Boundary" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "District",
        Value: "District",
        GraphicalSearchs: [
          { Text: "Active Sites - Polygon" },
          { Text: "Advisory Letter Cases" },
          { Text: "Advisory Letters" },
          { Text: "Advisory Projects" },
          { Text: "Antiquities and Monuments" },
          { Text: "Borehole Location" },
          { Text: "Boulder" },
          { Text: "DH Cases" },
          { Text: "DH Files" },
          { Text: "DH Orders" },
          { Text: "Disused Tunnel" },
          { Text: "Drainage and Sewage Tunnel Protection Zone" },
          { Text: "Emergency Works Services" },
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Feature Status Review (FSR)" },
          { Text: "GCC Cases" },
          { Text: "District Engineer Area" },
          { Text: "Ground Anchor" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Horizontal Drain" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Issued DBEL" },
          { Text: "Land Matter" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "NT Exempted House" },
          { Text: "NTHS (District)" },
          { Text: "Private Projects" },
          { Text: "Public Projects" },
          { Text: "Registered Squatter Dwelling - with CAF in force" },
          { Text: "Slope Checking Status (SCS)" },
          { Text: "Squatter Structure - close to slope" },
          { Text: "Stage 2 Study" },
          { Text: "Stage 3 Study" },
          { Text: "Stage 2(H) Study" },
          { Text: "Stage 3(H) Study" },
          { Text: "Strategic Cavern Areas" },
          { Text: "Tunnel Submission Records" },
          { Text: "Unauthorized Slope Works" },
          { Text: "Works Upgrading Boundary" },
          { Text: "Dangerous Road Sign" },
          { Text: "Squatter Warning Sign" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "GIRecord",
        Value: "GIRecord",
        GraphicalSearchs: [
          { Text: "GIU Report" },
          { Text: "GI Location", Default: true },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "Man-made Features" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "Planning",
        Value: "Planning",
        GraphicalSearchs: [
          { Text: "Boulder" },
          { Text: "Disused Tunnel" },
          { Text: "Drainage and Sewage Tunnel Protection Zone" },
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Landslide Studies Report Areas" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "Planning Comment (Area > 1 km2)" },
          { Text: "Planning Comment (Area < 1 km2)" },
          { Text: "Strategic Cavern Areas" },
          { Text: "Tension Crack (known)" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "Emergency",
        Value: "Emergency",
        GraphicalSearchs: [
          { Text: "Active Sites - Polygon" },
          { Text: "Advisory Letter Cases" },
          { Text: "Advisory Letters" },
          { Text: "Advisory Projects" },
          { Text: "Antiquities and Monuments" },
          { Text: "DH Cases" },
          { Text: "DH Files" },
          { Text: "DH Orders" },
          { Text: "Emergency Works Services" },
          { Text: "ENTLI Crown (2019)" },
          { Text: "ENTLI Trail (2019)" },
          { Text: "Feature Status Review (FSR)" },
          { Text: "Ground Anchor" },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Horizontal Drain" },
          { Text: "Incidents (Confirmed Cases)" },
          { Text: "Incidents (To be confirmed by LIC)" },
          { Text: "Landslide Studies Report Areas" },
          { Text: "Land Matter" },
          { Text: "Man-made Features", Default: true },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "NT Exempted House" },
          { Text: "NTHS (District)" },
          { Text: "Private Projects" },
          { Text: "Public Projects" },
          { Text: "Registered Squatter Dwelling - with CAF in force" },
          { Text: "Slope Checking Status (SCS)" },
          { Text: "Squatter Structure - close to slope" },
          { Text: "Stage 2 Study" },
          { Text: "Stage 3 Study" },
          { Text: "Stage 2(H) Study" },
          { Text: "Stage 3(H) Study" },
          { Text: "Unauthorized Slope Works" },
          { Text: "Works Upgrading Boundary" },
          { Text: "CUSTOM" },
        ],
      },
      {
        Text: "LandLot",
        Value: "iC1000_ginfo",
        GraphicalSearchs: [{ Text: "CUSTOM" }],
      },
      {
        Text: "DistrictArea",
        Value: "DistrictArea",
        GraphicalSearchs: [{ Text: "CUSTOM" }],
      },
    ],
  },

  Group9: {
    TextualSearchs: [
      { Text: "Man-made Features", Value: "ManMadeFeatureSearchBox" },
      { Text: "Road / Building / Place", Value: "StreetNameSearchBox" },
      { Text: "Lot Number", Value: "LotNumberSearchBox" },
      { Text: "Lamp Post", Value: "LampPostSearchBox" },
      { Text: "Coordinates", Value: "CoordinatesSearchBox" },
      { Text: "GIU Report", Value: "GIReportSearchBox" },
      {
        Text: "Active Sites - Districts",
        Value: "ActiveSitesDistrictsSearchBox",
      },
      {
        Text: "Active Sites - Civil Engineering Projects",
        Value: "ActiveSitesCEProjectSearchBox",
      },
      { Text: "Active Sites - LPM", Value: "ActiveSitesLPMSearchBox" },
      { Text: "Blasting Sites", Value: "BlastingSitesSearchBox" },
      { Text: "Boulder", Value: "BoulderSearchBox" },
      { Text: "CEDD - TGLA", Value: "CEDDTGLASearchBox" },
      { Text: "DADS", Value: "DADSSearchBox" },
      { Text: "Development Projects", Value: "DevelopmentProjectsSearchBox" },
      { Text: "ENTLI", Value: "ENTLISearchBox" },
      {
        Text: "Feature Status Review / Slope Checking Status",
        Value: "FSRSCSSearchBox",
      },
      { Text: "GCC Cases", Value: "GCCSearchBox" },
      { Text: "Hillside Pocket", Value: "HillsidePocketSearchBox" },
      { Text: "Historical Landslide Catchment (2016)", Value: "HLCSearchBox" },
      {
        Text: "Incidents (Confirmed / To be confirmed)",
        Value: "IncidentSearchBox",
      },
      { Text: "Issued DBEL", Value: "BulkExcavationSearchBox" },
      { Text: "LPM Stage 2(H) Study", Value: "LPMS2HSearchBox" },
      { Text: "LPM Stage 3(H) Study", Value: "LPMS3HSearchBox" },
      { Text: "Land Matter", Value: "LandMatterSearchBox" },
      { Text: "Landslide Studies Report Areas", Value: "LSRSearchBox" },
      { Text: "Map Sheet", Value: "MapSheetSearchBox" },
      { Text: "Mitigated Hillside (MH) Features", Value: "MHSearchBox" },
      { Text: "NT Exempted House", Value: "NTEHSearchBox" },
      { Text: "NTHS (District)", Value: "NTHSSearchBox" },
      {
        Text: "Registered Squatter Dwelling - with CAF in force",
        Value: "KSSWithNDCSearchBox",
      },
      { Text: "Tension Crack (Known)", Value: "TensionCrackSearchBox" },
      { Text: "Tunnel Submission Records", Value: "TunnelSearchBox" },
      { Text: "Unauthorized Slope Works", Value: "USWSearchBox" },
    ],
    Schemas: [
      {
        Text: "GIRecord",
        Value: "GIRecord",
        GraphicalSearchs: [
          { Text: "GIU Report" },
          { Text: "GI Location", Default: true },
          { Text: "Historical Landslide Catchment (2016)" },
          { Text: "Hillside Pocket" },
          { Text: "Mitigated Hillside (MH) Features" },
          { Text: "Man-made Features" },
        ],
      },
      {
        Text: "BulkExcLimit",
        Value: "BulkExcLimit",
        GraphicalSearchs: [{ Text: "Issued DBEL" }],
      },
    ],
  },

  CustomLayerInfos: [
    {
      LayerName: "Active Construction Sites (ACS)",
      ServiceName: "District",
      LayerIndex: 1,
      GCDIST1: false,
    },
    {
      LayerName: "Active Sites - Civil Engg. Projects",
      ServiceName: "SlopeInfo",
      LayerIndex: 49,
      GCDIST1: false,
    },
    {
      LayerName: "Active Sites - LPM",
      ServiceName: "SlopeInfo",
      LayerIndex: 47,
      GCDIST1: true,
    },
    {
      LayerName: "Advisory Letters",
      ServiceName: "SlopeInfo",
      LayerIndex: 10,
      GCDIST1: true,
    },
    {
      LayerName: "Advisory Projects",
      ServiceName: "SlopeInfo",
      LayerIndex: 14,
      GCDIST1: false,
    },
    {
      LayerName: "API Report",
      ServiceName: "District",
      LayerIndex: 43,
      GCDIST1: true,
    },
    {
      LayerName: "Blasting Sites",
      ServiceName: "SlopeInfo",
      LayerIndex: 57,
      GCDIST1: false,
    },
    {
      LayerName: "CEDD - TGLA",
      ServiceName: "SlopeInfo",
      LayerIndex: 51,
      GCDIST1: true,
    },
    {
      LayerName: "DH Orders",
      ServiceName: "SlopeInfo",
      LayerIndex: 8,
      GCDIST1: true,
    },
    {
      LayerName: "DH Files",
      ServiceName: "SlopeInfo",
      LayerIndex: 6,
      GCDIST1: true,
    },
    {
      LayerName: "District Engineer Area",
      ServiceName: "SlopeInfo",
      LayerIndex: 56,
      GCDIST1: false,
    },
    {
      LayerName: "Disused Tunnel",
      ServiceName: "District",
      LayerIndex: 61,
      GCDIST1: false,
    },
    {
      LayerName: "ENTLI Crown (2019)",
      ServiceName: "SlopeInfo",
      LayerIndex: 35,
      GCDIST1: false,
    },
    {
      LayerName: "ENTLI Trail (2019)",
      ServiceName: "SlopeInfo",
      LayerIndex: 36,
      GCDIST1: true,
    },
    {
      LayerName: "Existing Tunnel and Cavern",
      ServiceName: "SlopeInfo",
      LayerIndex: 58,
      GCDIST1: true,
    },
    {
      LayerName: "Feature Status Review (FSR)",
      ServiceName: "SlopeInfo",
      LayerIndex: 4,
      GCDIST1: true,
    },
    {
      LayerName: "GCC Cases",
      ServiceName: "SlopeInfo",
      LayerIndex: 15,
      GCDIST1: true,
    },
    {
      LayerName: "Ground Anchor",
      ServiceName: "SlopeInfo",
      LayerIndex: 17,
      GCDIST1: false,
    },
    {
      LayerName: "Historical Landslide Catchment (2016)",
      ServiceName: "SlopeInfo",
      LayerIndex: 41,
      GCDIST1: false,
    },
    {
      LayerName: "Hillside Pocket",
      ServiceName: "SlopeInfo",
      LayerIndex: 42,
      GCDIST1: false,
    },
    {
      LayerName: "Horizontal Drain",
      ServiceName: "SlopeInfo",
      LayerIndex: 18,
      GCDIST1: true,
    },
    {
      LayerName: "Incidents (Confirmed Cases)",
      ServiceName: "SlopeInfo",
      LayerIndex: 38,
      GCDIST1: true,
    },
    {
      LayerName: "Landslide Studies Report Areas",
      ServiceName: "SlopeInfo",
      LayerIndex: 37,
      GCDIST1: true,
    },
    {
      LayerName: "Land Matter",
      ServiceName: "SlopeInfo",
      LayerIndex: 20,
      GCDIST1: true,
    },
    {
      LayerName: "LPM Stage 2 Study",
      ServiceName: "SlopeInfo",
      LayerIndex: 28,
      GCDIST1: true,
    },
    {
      LayerName: "LPM Stage 3 Study",
      ServiceName: "SlopeInfo",
      LayerIndex: 29,
      GCDIST1: true,
    },
    {
      LayerName: "LPM Stage 2(H) Study",
      ServiceName: "SlopeInfo",
      LayerIndex: 30,
      GCDIST1: true,
    },
    {
      LayerName: "LPM Stage 3(H) Study",
      ServiceName: "SlopeInfo",
      LayerIndex: 31,
      GCDIST1: true,
    },
    {
      LayerName: "Man-made Features",
      ServiceName: "SlopeInfo",
      LayerIndex: 44,
      GCDIST1: true,
    },
    {
      LayerName: "MTR Protection Area",
      ServiceName: "District",
      LayerIndex: 85,
      GCDIST1: true,
    },
    {
      LayerName: "Registered Squatter Dwelling - with CAF in force",
      ServiceName: "SlopeInfo",
      LayerIndex: 1,
      GCDIST1: true,
    },
    {
      LayerName: "Planning Comment (Area > 1 km2)",
      ServiceName: "Planning",
      LayerIndex: 2,
      GCDIST1: true,
    },
    {
      LayerName: "Planning Comment (Area < 1 km2)",
      ServiceName: "Planning",
      LayerIndex: 1,
      GCDIST1: true,
    },
    {
      LayerName: "Private Projects",
      ServiceName: "SlopeInfo",
      LayerIndex: 13,
      GCDIST1: true,
    },
    {
      LayerName: "Public Projects",
      ServiceName: "SlopeInfo",
      LayerIndex: 12,
      GCDIST1: true,
    },
    {
      LayerName: "Scheduled/Designated Areas",
      ServiceName: "District",
      LayerIndex: 58,
      GCDIST1: false,
    },
    {
      LayerName: "Slope Checking Status (SCS)",
      ServiceName: "SlopeInfo",
      LayerIndex: 5,
      GCDIST1: false,
    },
    {
      LayerName: "Squatter Structure - close to slope",
      ServiceName: "SlopeInfo",
      LayerIndex: 2,
      GCDIST1: true,
    },
    {
      LayerName: "Studies Area",
      ServiceName: "District",
      LayerIndex: 59,
      GCDIST1: false,
    },
    {
      LayerName: "Unauthorized Slope Works",
      ServiceName: "SlopeInfo",
      LayerIndex: 16,
      GCDIST1: false,
    },
  ],
};
